var React = require('react');

function Explore (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM15.2,9.6c-1.1,1.7-3.3,4.2-7.2,4.2c-3.9,0-6.1-2.6-7.1-4.2","key":0}),React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","cx":"8","cy":"8","r":"4","key":1}),React.createElement("path",{"fill":"currentColor","d":"M10,8c0,1.1-0.9,2-2,2S6,9.2,6,8s0.9-2,2-2v2H10z","key":2}),React.createElement("path",{"fill":"none","stroke":"currentColor","strokeWidth":"0.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","d":"\n\t\tM0.3,7.7C0.8,6.5,2.9,2.2,8,2.2c4.7,0,7,4,7.7,5.5","key":3})]));
}

Explore.displayName = "Explore";

Explore.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","enableBackground":"new 0 0 16 16","xmlSpace":"preserve"};

module.exports = Explore;

Explore.default = Explore;



//////////////////
// WEBPACK FOOTER
// ../icon/src/icons/explore.svg
// module id = ../icon/src/icons/explore.svg
// module chunks = 0